import { useEffect, useState } from 'react';
import { getSummaryCard } from '../services';
import { ISummaryCardItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useSummaryCard(options?: {
	sellerId?: number;
	team?: string;
	skip?: boolean;
}): HookState<ISummaryCardItem[]> {
	const [state, setState] = useState<HookState<ISummaryCardItem[]>>({
		data: null,
		loading: false,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;
	const skip = options?.skip ?? false;

	useEffect(() => {
		if (skip) {
			setState({ data: null, loading: false, error: null, cachedAt: null });
			return;
		}

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getSummaryCard({ sellerId, team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [sellerId, team, skip]);

	return state;
}
